<template>
    <Head :title="`Статистика: ${player.full_name}`" />
    
    <MainLayout>
        <div class="stats-page">
            <div class="section-header">
                <Link href="/" class="back-link">← Назад</Link>
            </div>

            <!-- Player Header -->
            <div class="player-header">
                <div class="player-avatar">
                    <img v-if="player.photo_url" :src="player.photo_url" :alt="player.full_name" />
                    <span v-else class="avatar-placeholder">{{ player.full_name?.charAt(0) }}</span>
                </div>
                <div class="player-details">
                    <h1>{{ player.full_name }}</h1>
                    <div class="player-meta">
                        <span v-if="player.number" class="number-badge">#{{ player.number }}</span>
                        <span v-if="player.position" class="position">{{ positionNames[player.position] || player.position }}</span>
                    </div>
                </div>
            </div>

            <!-- Total Stats -->
            <div class="stats-section">
                <h2>Общая статистика</h2>
                <div class="stats-grid">
                    <div class="stat-card">
                        <div class="stat-value">{{ totalStats.total_actions }}</div>
                        <div class="stat-label">Всего действий</div>
                    </div>
                    <div class="stat-card">
                        <div class="stat-value">{{ totalStats.attacks }}</div>
                        <div class="stat-label">Атаки</div>
                    </div>
                    <div class="stat-card">
                        <div class="stat-value">{{ totalStats.serves }}</div>
                        <div class="stat-label">Подачи</div>
                    </div>
                    <div class="stat-card">
                        <div class="stat-value">{{ totalStats.blocks }}</div>
                        <div class="stat-label">Блоки</div>
                    </div>
                    <div class="stat-card">
                        <div class="stat-value">{{ totalStats.receptions }}</div>
                        <div class="stat-label">Приёмы</div>
                    </div>
                    <div class="stat-card positive">
                        <div class="stat-value">{{ totalStats.kills }}</div>
                        <div class="stat-label">Очки</div>
                    </div>
                    <div class="stat-card negative">
                        <div class="stat-value">{{ totalStats.errors }}</div>
                        <div class="stat-label">Ошибки</div>
                    </div>
                </div>
            </div>

            <!-- Match Stats -->
            <div class="matches-section" v-if="matchStats.length">
                <h2>По матчам</h2>
                <div class="matches-table">
                    <table>
                        <thead>
                            <tr>
                                <th>Дата</th>
                                <th>Матч</th>
                                <th>Действий</th>
                                <th>Атаки</th>
                                <th>Очки</th>
                                <th>Ошибки</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="match in matchStats" :key="match.match_id">
                                <td>{{ match.match_date }}</td>
                                <td>{{ match.opponent }}</td>
                                <td>{{ match.total_actions }}</td>
                                <td>{{ match.attacks }}</td>
                                <td class="positive">{{ match.kills }}</td>
                                <td class="negative">{{ match.errors }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </MainLayout>
</template>

<script setup>
import { Head, Link } from '@inertiajs/vue3';
import MainLayout from '@/components/layout/MainLayout.vue';

const props = defineProps({
    player: Object,
    matchStats: Array,
    totalStats: Object,
});

const positionNames = {
    setter: 'Связующий',
    outside: 'Доигровщик',
    opposite: 'Диагональный',
    middle: 'Блокирующий',
    libero: 'Либеро',
};
</script>
